import React, { useEffect, useState } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Popover, Space, Upload } from "antd";

import "./FileUploadWithThumb.css";

const FileUploadWithThumb = (props) => {
    const { label, action, maxCount = 1, onFileUpload, CustomFileUpload, onRemove, files, isClose } = props
    const [fileList, setFileList] = useState(files !== undefined && files?.length > 0 ? files : []);

    const beforeUpload = (file) => {
        // Check if the current file count is less than the maximum count
        return fileList.length < maxCount;
    };

    const onChange = ({ file, fileList: newFileList }) => {
        // Update the file list
        setFileList(newFileList);
        onFileUpload(newFileList)
    };

    useEffect(() => {
        if (files !== undefined && files?.length > 0) {
            setFileList(files);
        }
    }, [files])

    useEffect(() => {
        if (isClose !== undefined && isClose !== null && isClose) {
            setFileList([]);
        }
    }, [isClose])

    return (
        <div className="file-upload-section uploadCard">
            <div className="file-upload-head">
                <h2>{label}</h2>
                {/* <Popover content={"Coming soon"} className="mt-[-4px]">
                    <img
                        src="/images/fi_info.svg"
                        alt="info"
                        className="inline-block ml-[8px] cursor-pointer"
                    />
                </Popover> */}
            </div>
            <Space direction="vertical" style={{ width: "100%" }} size="large">
                <Upload
                    action={action}
                    customRequest={CustomFileUpload}
                    listType="picture"
                    maxCount={maxCount}
                    beforeUpload={beforeUpload}
                    onChange={onChange}
                    onRemove={onRemove}
                    fileList={fileList}
                    accept=".png,.jpeg,.jpg,.docx,.doc,.pdf"
                >
                    <button
                        type="button"
                        disabled={fileList.length >= maxCount}
                        className="file-upload-btn"
                    >
                        Max: {maxCount} file{maxCount > 1 ? "s" : ""}
                        <span>
                            <UploadOutlined /> Upload
                        </span>
                    </button>
                </Upload>
            </Space>
        </div>
    );
};

export default FileUploadWithThumb;
